export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 8_01.9415d40e.jpg";